import MobileLayout from './AvatarInputLayout.mobile';
import WebLayout from './AvatarInputLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
